export const VOTED_FOR_POLL = 'announcements/VOTED_FOR_POLL';
